/*** IMPORTS FROM imports-loader ***/
var me = {};

me.Urls = (function () {

    var Urls = {};

    var self = {
        url_patterns:{}
    };

    var _get_url = function (url_pattern) {
        return function () {
            var _arguments, index, url, url_arg, url_args, _i, _len, _ref,
                _ref_list, match_ref, provided_keys, build_kwargs;

            _arguments = arguments;
            _ref_list = self.url_patterns[url_pattern];

            if (arguments.length == 1 && typeof (arguments[0]) == "object") {
                // kwargs mode
                var provided_keys_list = Object.keys (arguments[0]);
                provided_keys = {};
                for (_i = 0; _i < provided_keys_list.length; _i++)
                    provided_keys[provided_keys_list[_i]] = 1;

                match_ref = function (ref)
                {
                    var _i;

                    // Verify that they have the same number of arguments
                    if (ref[1].length != provided_keys_list.length)
                        return false;

                    for (_i = 0;
                         _i < ref[1].length && ref[1][_i] in provided_keys;
                         _i++);

                    // If for loop completed, we have all keys
                    return _i == ref[1].length;
                }

                build_kwargs = function (keys) {return _arguments[0];}

            } else {
                // args mode
                match_ref = function (ref)
                {
                    return ref[1].length == _arguments.length;
                }

                build_kwargs = function (keys) {
                    var kwargs = {};

                    for (var i = 0; i < keys.length; i++) {
                        kwargs[keys[i]] = _arguments[i];
                    }

                    return kwargs;
                }
            }

            for (_i = 0;
                 _i < _ref_list.length && !match_ref(_ref_list[_i]);
                 _i++);

            // can't find a match
            if (_i == _ref_list.length)
                return null;

            _ref = _ref_list[_i];
            url = _ref[0], url_args = build_kwargs(_ref[1]);
            for (url_arg in url_args) {
            	var url_arg_value = url_args[url_arg];
            	if (url_arg_value === undefined || url_arg_value === null) {
            		url_arg_value = '';
            	} else {
            		url_arg_value = url_arg_value.toString();
            	}
                url = url.replace("%(" + url_arg + ")s", url_arg_value);
            }
            return '/' + url;
        };
    };

    var name, pattern, url, url_patterns, _i, _len, _ref;
    url_patterns = [
        
            [
                'front:api:buy\u002Dcommercial',
                [
                    
                    [
                        'api/buy/commercial/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:buy\u002Dflat',
                [
                    
                    [
                        'api/buy/flat/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:buy\u002Dhouse',
                [
                    
                    [
                        'api/buy/house/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:buy\u002Droom',
                [
                    
                    [
                        'api/buy/room/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:callback',
                [
                    
                    [
                        'api/callback/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:feedback',
                [
                    
                    [
                        'api/feedback/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:index',
                [
                    
                    [
                        'api/index/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:let\u002Dcommercial',
                [
                    
                    [
                        'api/let/commercial/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:let\u002Dothers',
                [
                    
                    [
                        'api/let/flat\u002Droom\u002Dhouse/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:mortgage',
                [
                    
                    [
                        'api/mortgage/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:object',
                [
                    
                    [
                        'api/object/%(obj_id)s/',
                        [
                            
                            'obj_id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:rent\u002Dcommercial',
                [
                    
                    [
                        'api/rent/commercial/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:rent\u002Dothers',
                [
                    
                    [
                        'api/rent/flat\u002Droom\u002Dhouse/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:sell\u002Dcommercial',
                [
                    
                    [
                        'api/sell/commercial/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:sell\u002Dflat',
                [
                    
                    [
                        'api/sell/flat/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:sell\u002Dhouse',
                [
                    
                    [
                        'api/sell/house/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:sell\u002Droom',
                [
                    
                    [
                        'api/sell/room/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:api:urgent\u002Dsell',
                [
                    
                    [
                        'api/urgent\u002Dsell/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:buy\u002Dcommercial',
                [
                    
                    [
                        'buy/commercial/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:buy\u002Dflat',
                [
                    
                    [
                        'buy/flat/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:buy\u002Dhouse',
                [
                    
                    [
                        'buy/house/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:buy\u002Droom',
                [
                    
                    [
                        'buy/room/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:feedback',
                [
                    
                    [
                        'feedback/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:index',
                [
                    
                    [
                        '',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:let\u002Dcommercial',
                [
                    
                    [
                        'let/commercial/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:let\u002Dothers',
                [
                    
                    [
                        'let/flat\u002Droom\u002Dhouse/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:mortgage',
                [
                    
                    [
                        'mortgage/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:object',
                [
                    
                    [
                        'object/%(obj_id)s/',
                        [
                            
                            'obj_id',
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:oh\u002Dmy\u002Dgod',
                [
                    
                    [
                        'oh\u002Dmy\u002Dgod/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:rent\u002Dcommercial',
                [
                    
                    [
                        'rent/commercial/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:rent\u002Dothers',
                [
                    
                    [
                        'rent/flat\u002Droom\u002Dhouse/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:robots',
                [
                    
                    [
                        'robots.txt',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:sell\u002Dcommercial',
                [
                    
                    [
                        'sell/commercial/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:sell\u002Dflat',
                [
                    
                    [
                        'sell/flat/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:sell\u002Dhouse',
                [
                    
                    [
                        'sell/house/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:sell\u002Droom',
                [
                    
                    [
                        'sell/room/',
                        [
                            
                        ]
                    ]
                    
                ],
            ],
        
            [
                'front:urgent\u002Dsell',
                [
                    
                    [
                        'urgent\u002Dsell/',
                        [
                            
                        ]
                    ]
                    
                ]
            ]
        
    ];
    self.url_patterns = {};
    for (_i = 0, _len = url_patterns.length; _i < _len; _i++) {
        _ref = url_patterns[_i], name = _ref[0], pattern = _ref[1];
        self.url_patterns[name] = pattern;
        url = _get_url(name);
        Urls[name] = url;
        Urls[name.replace(/-/g, '_')] = url;
    }

    return Urls;
})();


/*** EXPORTS FROM exports-loader ***/
module.exports = me.Urls;



//////////////////
// WEBPACK FOOTER
// ./assets/js/django_js_front/reverse.js
// module id = 90
// module chunks = 0